<template>
  <div class="hello flex_c" style="width: 100%;height: 100%">
    <div style="width: 100%;height: 100%;background-color: White;padding: 0 35px 0 35px">

      <div class="row top" >
        <div  style="text-align: left;font-size: 20px"><span style="color: #5E4FFF">hi,</span> &nbsp;欢迎来到工作啦！</div>
      </div>
      <el-button v-if="!openid" class="getAuthBtn" @click="gotoLogin()">获取微信权限</el-button>

      <el-form ref="form" v-if="openid" :model="form" :label-width="needEditPsw?'100px':'60px'" style="margin-top: 80px">
        <el-form-item label="学校:" v-if="collegeDetail">
          {{collegeDetail.name}}
        </el-form-item>
        <el-form-item label="学号:">
          <el-input v-model="form.no" placeholder="请输入学号"></el-input>
        </el-form-item>
        <el-form-item label="密码:">
          <el-input type="password" v-model="form.psw" placeholder="请输入密码，默认身份证后六位"></el-input>
        </el-form-item>
        <div v-if="needEditPsw" style="margin-left:100px;margin-bottom:20px;">首次登录请修改密码</div>
        <el-form-item v-if="needEditPsw" label="重置密码:">
          <el-input type="password" v-model="form.new_password" placeholder="请输入密码，默认身份证后六位" @blur="passwordBlur"></el-input>
          <div class="strength_box" v-if="form.new_password" :class="'strength_box' + password_strength">
            <div :class="'password_strength' + password_strength"></div>
            <div class="strength_message">{{password_strength_message}}</div>
          </div>
        </el-form-item>
        <el-form-item v-if="needEditPsw" label="确认重置密码:">
          <el-input type="password" v-model="form.confirm_password" placeholder="请输入密码，默认身份证后六位"></el-input>
        </el-form-item>
        <el-form-item label="验证码:">
          <el-input v-model="form.vcode_verify.vcode_text" placeholder="请输入验证码">
            <template #append>
              <img style="margin:0 -20px;width: 100px;height:38px;vertical-align:middle" :src="imgCode" @click="getVcode()" />
            </template>
          </el-input>
        </el-form-item>
        <el-button class="bind" type="primary" @click="bindBtn()">下一步</el-button>
        <div style="padding: 0 15px 0 15px;margin-top: 15px">
          <span style="color: #999999;font-size: 14px;margin-top: 20px">温馨提示：若遇到问题，请联系就业办</span><br/>
          <span style="color: #999999;font-size: 14px;" v-if="office_tel">电话：{{office_tel}}</span>
        </div>
      </el-form>
      <div style="margin-top: 15px;text-align: center;width: 100%;color: #aaaaaa">V 1.1.4</div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'HelloWorld',
  data () {
    return {
      needEditPsw: false,
      imgCode: '',
      password_strength_message: '',
      password_strength: '',
      msg: 'Welcome to Your Vue.js App',
      visible: false,
      skip_uri: encodeURIComponent('http://wx.talent.goworkla.cn/#/wxBind'),
      // skip_uri: encodeURIComponent('http://wx.talent.test.goworkla.cn/#/wxBind'),
      // skip_uri: encodeURIComponent('http://192.168.1.110:8080/#/wxBind'),
      collegeId: '',
      openid: '',
      form: {
        no: '',
        psw: '',
        new_password: '',
        confirm_password: '',
        vcode_verify: {
          vcode_text: '',
          vcodeid: ''
        }
      },
      collegeDetail: null,
      office_tel: ''
    }
  },
  created() {
    localStorage.removeItem('access_token')

    console.log('公共加载',window.location.href)
    if (this.$route.query.openid) {
      // alert('open' + this.$route.query.openid)
      this.openid = this.$route.query.openid
      this.toast.success('授权成功')
      // this.virtyUserisBind();
    }

    if (this.$route.query.collegeId || this.$route.query.collegeid) {
      this.collegeId = this.$route.query.collegeId
      if (this.$route.query.collegeid) {
        this.collegeId = this.$route.query.collegeid
      }
      this.getCollageDetails()
    }
    if (!this.openid) {
       this.gotoLogin()
    }

    this.getVcode()
  },
  methods: {
    xcx() {
      var ua = window.navigator.userAgent.toLowerCase();
      // 微信内核判断
      if (ua.indexOf('micromessenger') === -1) {
        this.showLoginPopup = true
        this.isWeixinOpen = false
      }
      let wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
      let judgewechat;
      if (wechat) {
        judgewechat = wechat[1].split('.');
        if (judgewechat[0] >= 7) {
          if (judgewechat[1] >= 0) {
            if (judgewechat[2] >= 12) {

              console.log('当前符合 h5 打开小程序');
              console.log(location.href.split('#')[0], 'location.href.split(\'#\')[0]');
              let params = {
                collegeid: 'wechatofficial0000talent',
                 url: encodeURIComponent(location.href.split('#')[0]),
                //url: encodeURIComponent('http://tianji.wap.goworkla.cn/'),
                type: 'talentservice'
              }
              this.$api.getWechatInfo(params)
                .then((res) => {
                  console.log(res, 'getWechatJssdk1');
                  if (res) {
                    var wxConfigArr = []
                    // 通过config接口注入 权限验证配置并申请所需开放标签
                    wx.config({
                      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
                      appId: res.AppId, // 必填，公众号的唯一标识
                      timestamp: res.Timestamp, // 必填，生成签名的时间戳
                      nonceStr: res.NonceStr, // 必填，生成签名的随机串
                      signature: res.Signature,// 必填，签名
                      jsApiList: ['wx-open-launch-weapp'], // 必填，需要使用的JS接口列表
                      openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app'],
                    })

                    wx.error(function (res) {
                      console.log('error', res)
                      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
                    })
                    wxConfigArr.push(res.AppId,res.Timestamp,res.NonceStr,res.Signature);
                    console.log('初始化成功', wxConfigArr)
                  } else {
                    this.showLoginPopup = true
                    this.isWeixinOpen = true
                  }
                });

            } else {
              this.showLoginPopup = true;
              this.isWeixinOpen = true;
            }
          }
        }
      }
    },
    gotoLogin () {
      // + "&redirect_uri="+ this.skip_uri;
      //  let url = 'http://wx.test.goworkla.cn/mp/redirect?collegeid=' + this.collegeId + '&v=' + (new Date().getTime()) + '&redirect_uri=' + this.skip_uri
      let url = 'http://wx.goworkla.cn/mp/redirect?collegeid=' + this.collegeId + '&v=' + (new Date().getTime()) + '&redirect_uri=' + this.skip_uri
      // let url = 'http://gwl.ngrok2.xiaomiqiu.cn/mp/redirect?collegeid=' + this.collegeId + '&v=' + (new Date().getTime())+ "&redirecturi="+ this.skip_uri;
      // let url = 'http://gwl.ngrok2.xiaomiqiu.cn/mp/redirect?collegeid=5ab99b55d041fd4014a3b8f4&redirecturi=http://wx.talent.goworkla.cn/wxBindX'
      console.log(url)
       window.location.href = url
    },
    getCollageDetails() {
     this.$api.getCollageDetails(this.collegeId)
        .then(res => {
          if (res) {
            this.collegeDetail = res
            if (this.collegeDetail.work_info.office_tel) {
              if (this.collegeDetail.work_info) {
                this.office_tel = this.collegeDetail.work_info.office_tel
              }
            }
          }
        }).catch(e => {
        if (e.Errmsg) {
          this.$message({message: e.Errmsg, type: 'error'});
        }
      })
    },
    bindBtn() {
      if (!this.collegeId) {
        alert('获取高校错误')
        return false
      }
      if (!this.openid) {
        alert('授权错误')
        return false
      }
      if (!this.form.no) {
        alert('学号错误')
        return false
      }
      if (!this.form.psw) {
        alert('密码错误')
        return false
      }
      if (!this.form.vcode_verify.vcode_text) {
        alert('请输入验证码')
        return false
      }
      if (this.needEditPsw && !this.form.new_password) {
        alert('请输入重置密码')
        return false
      }
      if (this.needEditPsw && !this.form.confirm_password) {
        alert('请输入确认重置密码')
        return false
      }
      if (this.needEditPsw && this.form.confirm_password !== this.form.new_password) {
        alert('确认重置密码与重置密码不一致')
        return false
      }
      let data = {
        login_type: 'no',
        collegeid: this.collegeId,
        no: this.form.no,
        password: this.form.psw,
        account_type: 'talent',
        wechat_bind: {
          openid: this.openid
        },
        vcode_verify: this.form.vcode_verify
      }
      if (this.needEditPsw) data.new_password = this.form.new_password
      this.$api.accountLogin(data)
        .then(res => {
          if (res) {
            this.getToken(res.value)
          }
        }).catch(e => {
          if (e.Errmsg) {
            this.toast.err(e.Errmsg)
          }
          if (e.Errcode === '1106') {
            this.$router.push('/wxBindPhone?' + 'openid=' + this.openid + '&collegeId=' + this.collegeId + '&no=' + this.form.no + '&psw=' + this.form.psw + '&new_password=' + this.form.new_password)
          } else if (e.Errcode === '1111') {
            this.needEditPsw = true
            this.getVcode()
          }
        })
    },
    getToken(code) {
      let data = {
        'grant_type': 'authorization_code',
        'code': code,
        'refresh_token': '',
        'loginname': '',
        'password': '',
        'login_source': ''
      }
      this.$api.getToken(data).then(res => {
          if (res) {
            console.log('getToken', res)
            localStorage.setItem('accesstoken',res.access_token)
            this.getUserInfo()
          }
        }).catch(e => {
        if (e.Errmsg) {
          this.toast.err(e.Errmsg)
        }
      })
    },
    getUserInfo() {
      // getUser
      console.log('getUserInfo')
      this.$api.getUser().then(res => {
        console.log('getUser', res)
        if (res.mobile_actived === false) {
          this.$router.push('/wxBindPhone?' + 'openid=' + this.openid + '&collegeId=' + this.collegeId + '&no=' + this.form.no + '&psw=' + this.form.psw)
        } else {
          this.toast.success('绑定成功')
          this.$router.push('/bindSuccess')
        }
      }).catch(e => {
        if (e.Errmsg) {
          this.toast.err(e.Errmsg)
        }
      })
    },
    virtyUserisBind() {
      let postdata = {
        login_type: 'wechat_mp',
        collegeid: this.collegeId,
        openid: this.openid
      }
      this.$api.accountLogin(postdata)
        .then(res => {
          if (res) {
            console.log('自动验证',res,this.openid);

            this.getToken(res.value)
          }
        }).catch(e => {

      })
    },
    getVcode () {
      this.$api.getVcode().then(res => {
        this.imgCode = `data:image/png;base64,${res.vcode_image}`
        this.form.vcode_verify.vcodeid = res.vcodeid
      })
    },
    passwordBlur() {
      if (!this.form.new_password) {
        this.password_strength_message = ''
        this.password_strength = ''
        return
      }
      this.$api.userPasswordCheckSafety({password: this.form.new_password}).then(res => {
        console.log(11111, res)
        this.password_strength = res.score + 1
        this.password_strength_message = ['', '密码强度极低，极易被破解', '密码强度低，可不太安全', '密码强度中等，存在一定风险', '密码强度高，安全性较好', '密码强度极高，安全性强'][this.password_strength]
        if (!this.password_strength) {
          this.password_strength_message = res.message
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.top
{
  margin-top: 55px;
}
  .getAuthBtn
  {
    width: 60%;
    margin-left: 20%;
    margin-top: 220px;
  }
  .bind {
     width: 250px;
    margin-left: calc((100% - 250px)/2);
    margin-top: 60px;
  }

  /** 自定义密码强度条 */
  [class*=password_strength] {
    height: 4px;
    background-color: #ddd;
    width: 200px;
    min-width: 200px;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
  }

  [class*=password_strength]::before {
    content: '';
    position: absolute;
    width: 0;
    height: 100%;
    transition: all 0.3s;
  }

  .password_strength1::before {
    width: 20%;
    background-color: #ff5722;
  }

  .password_strength2::before {
    width: 40%;
    background-color: #ff5722;
  }

  .password_strength3::before {
    width: 60%;
    background-color: #ffb82f;
  }

  .password_strength4::before {
    width: 80%;
    background-color: #5fb878;
  }

  .password_strength5::before {
    width: 100%;
    background-color: #5fb878;
  }

  [class*=password_strength]::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: repeating-linear-gradient(to right, transparent 0%, transparent 18%, #fff 18%, #fff 20.5%);
  }

  [class*=strength_box] {
    margin-top: 5px;
    color: #ff5722;
  }

  .strength_box3 {
    color: #ffb82f;
  }

  .strength_box4 {
    color: #5fb878;
  }

  .strength_box5 {
    color: #5fb878;
  }

  .strength_message {
    min-width: 100%;
    font-size: 12px;
    margin-top: 4px;
    line-height: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue